import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {

	// Agrego withCredentials para que en el request se agreguen las cookies, 
	// en particular media, y también para aceptar la creación de cookies del servidor
	intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		// Importante!
		// Hay que tener especial cuidado de no enviar { withCredentials: true } a peticiones
		// a PHP, dado que PHP no tiene en su "CorsFilter" el Access-Control-Allow-Credentials: true,
		// si se envía estaremos generando un error.
		
		let observable: Observable<HttpEvent<any>>;
		if( req.url.endsWith( 'php' ) ) {
			observable = next.handle( req );
		} else {
			const cloned = req.clone( { withCredentials: true } );
			observable = next.handle( cloned );
		}
		return observable;
	}

}